import { defineMessages } from "react-intl";

const CONTENT_TYPE = "content-type";

const contentTypeMessages = defineMessages({
  journalAlerts: {
    id: `${CONTENT_TYPE}.journal-alerts`,
    defaultMessage: "Journal alerts ({count})"
  },
  projects: {
    id: `${CONTENT_TYPE}.projects`,
    defaultMessage: "Projects ({count})"
  },
  savedRecords: {
    id: `${CONTENT_TYPE}.saved-records`,
    defaultMessage: "Saved records ({count})"
  },
  savedSearches: {
    id: `${CONTENT_TYPE}.saved-searches`,
    defaultMessage: "Saved searches ({count})"
  },
  searchAlerts: {
    id: `${CONTENT_TYPE}.search-alerts`,
    defaultMessage: "Search alerts ({count})"
  }
});

export default contentTypeMessages;
